import { render, staticRenderFns } from "./InputMask.vue?vue&type=template&id=6b9f2af1&"
import script from "./InputMask.vue?vue&type=script&lang=js&"
export * from "./InputMask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports